<template>
  <div class="header-container">
    <div class="header-content">
      <div class="info-box">
        <div class="school-logo">
          <img src="../../assets/hzvtc/common/school-logo.png">
        </div>
        <div class="platform-name">党建思政教育资源平台</div>
      </div>
      <div class="handle-box">
        <div class="search">
          <div class="normal" v-if="!search" @click="search = true"></div>
          <div class="active" v-else>
            <input type="text" v-model="keywords" @keyup.enter="handleSearch" placeholder="请输入搜索内容">
            <div class="handle-search" @click="handleSearch"></div>
          </div>
        </div>
        <a href="https://www.hzvtc.edu.cn/" target="_blank" class="home">学校首页</a>
        <div :class="['eol-right-user', menuOpen ? 'up' : 'down']" @mouseleave="menuOpen = false" @click="menuOpen = !menuOpen">
          <div class="login-btn" v-if="!loginUserInfo" @click="handleLogin()">登录</div>
          <template v-else>
            <div class="mine-lines">
              <div class="user-imgs-box"></div>
              <span>{{loginUserInfo && loginUserInfo.name ? loginUserInfo.name :  loginUserInfo && loginUserInfo.username}}</span>
            </div>
            <ul @mouseleave="menuOpen = false" class="eol-submine-box">
              <!-- <li class="submine-items">
                <a :href="`${services.LOGIN_SERVER}/${school_code}/worker`">信息服务中心</a>
              </li>
              <li class="submine-items">
                <a :href="`${services.LOGIN_SERVER}/${school_code}/userInfo`">个人信息</a>
              </li>
              <li class="submine-items">
                <a :href="`${services.LOGIN_SERVER}/${school_code}/editPassword`">修改密码</a>
              </li> -->
              <li class="submine-items" v-if="showXuexi">
                <a target="_blank" :href="`${services.XUEXI_HOST}/school/${school_code}`">在线学习培训管理</a>
              </li>
              <li class="submine-items" @click="logoutEvents">
                <a href="javascript:;">退出登录</a>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import utils from '../../config/utils';
import services from '../../config/services';
export default {
  data () {
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      search: false, // 是否显示搜索框
      keywords: "", // 搜索关键词
      services,
      menuOpen: false,
      xuexiUserInfo: {},
      showXuexi: false,
    }
  },
  props: {
    p_search: {
      type: Boolean
    },
    content: {
      type: String
    }
  },
  async mounted () {
    this.search = this.p_search
    this.keywords = this.content
    await this.getAppsLoginUserInfo().then(res => {
      if (res.code == '0000') {
        this.getLoginSchoolInfo({ school_code: res.data.school_code });
        // if (!this.school_code) {
        this.school_code = res.data.school_code;
        // }
      }
    })
    // 如果访问的是杭职院党建思政育人平台,学校code不是杭职院code，强制返回登录页
    await this.judgeSchool()
    await this.getXuexiInfo()
  },
  methods: {
    ...mapActions(["requestAppsLogout", 'getAppsLoginUserInfo', "getLoginSchoolInfo"]),
    // 关键词搜索
    handleSearch () {
      window.open(`/center/${this.school_code}/hzvtc/search?keywords=${this.keywords}`)
    },
    // 退出登录
    logoutEvents () {
      let that = this
      if (window.location.href.indexOf("hzvtc/detail") > -1) {
        localStorage.setItem("eol-hzvtc-detail-key", this.$route.query.key)
      }
      this.requestAppsLogout()
      // .then(res => {
      //   if (res.code == '0000') {
      //     if (!res.data || !res.data.redirect) {
      //       if (this.$route.path.indexOf("hzvtc") == -1) return
      //       if (that.school_code) {
      //         window.open(`${services.LOGIN_SERVER}/${that.school_code}/login?from=${window.location.href}`, "_self")
      //       }
      //     }
      //   }
      // })
    },
    // 点击登录
    handleLogin () {
      if (window.location.href.indexOf("hzvtc/detail") > -1) {
        localStorage.setItem("eol-hzvtc-detail-key", this.$route.query.key)
      }
      window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")
    },
    // 判断学校是否是杭职院code,如果不是不允许访问,带杭职院code跳转到信息服务中心
    judgeSchool () {
      if (this.school_code != services.HZ_CODE) {
        let path = `${window.location.origin}/center/${services.HZ_CODE}/hzvtc`
        // window.open(`${services.LOGIN_SERVER}/${services.HZ_CODE}/login?from=${path}`, "_self")
        window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${path}`, "_self")
      }

    },
    getXuexiInfo () {
      services.getXuexiUser().then(res => {
        this.xuexiUserInfo = res.data
        if (res && res.data) {
          if (res.data.role_ids || res.data.user_type) {
            if (res.data.role_ids == '1' || res.data.role_ids == '2' || res.data.user_type == '2') {
              this.showXuexi = true
            }
          }
        }
      })
    }

  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
      schoolInfo: (state) => state.appsLogin.schoolInfo,
    }),
  },
}
</script>

<style lang="less" scoped>
.header-container {
  width: 100%;
  height: 80px;
  background: #ffffff;
  display: flex;
  align-items: center;
  .header-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    .info-box {
      display: flex;
      align-items: center;
      .school-logo {
        width: auto;
        img {
          width: auto;
          max-height: 44px;
        }
      }
      .platform-name {
        font-size: 22px;
        font-weight: bold;
        color: #b61e2a;
        display: flex;
        align-items: center;
        &::before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 28px;
          background: #e9e6e4;
          margin: 0 15px 0 21px;
        }
      }
    }
    .handle-box {
      display: flex;
      align-items: center;
      height: 100%;
      .search {
        .normal {
          width: 21px;
          height: 21px;
          background: url('../../assets/hzvtc/index/search.png') no-repeat
            center/cover;
          cursor: pointer;
        }
        .active {
          display: flex;
          align-items: center;
          position: relative;
          input {
            width: 260px;
            height: 34px;
            line-height: 34px;
            background: #f3f5f6;
            padding: 0 50px 0 14px;
            border: none;
            &::placeholder {
              font-size: 14px;
              color: #a6a6a6;
            }
          }
          .handle-search {
            width: 20px;
            height: 20px;
            background: url('../../assets/hzvtc/index/search.png') no-repeat
              center/cover;
            cursor: pointer;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
          }
        }
      }
      .home,
      .login-btn {
        font-size: 16px;
        color: #333333;
        height: 100%;
      }
      .home {
        margin: 0 24px;
        display: flex;
        align-items: center;
        &::before,
        &::after {
          content: '';
          display: inline-block;
          width: 1px;
          height: 18px;
          background: #e4e4e4;
        }
        &::before {
          margin-right: 24px;
        }
        &::after {
          margin-left: 24px;
        }
      }

      .login-btn {
        display: flex;
        align-items: center;
        cursor: pointer;
        &::before {
          content: '';
          display: inline-block;
          width: 15px;
          height: 14px;
          background: url('../../assets/hzvtc/index/login-user.png') no-repeat
            center/cover;
          margin-right: 6px;
          vertical-align: middle;
        }
      }

      .eol-right-user {
        display: inline-block;
        vertical-align: top;
        margin-right: 30px;
        max-width: 260px;
        position: relative;
        height: 100%;
      }

      .eol-right-user .close-page-box {
        position: absolute;
        display: inline-block;
        font-size: 16px;
        color: #3a3a3a;
        display: inline-block;
        margin-left: 5px;
        top: 13px;
        left: -80px;
        cursor: pointer;
      }

      .eol-right-user .close-page-box img {
        vertical-align: -4px;
      }

      .eol-right-user .mine-lines {
        height: 100%;
        font-size: 14px;
        font-weight: 400;
        color: #125cfb;
        cursor: pointer;
        display: flex;
        align-items: center;
      }

      .eol-right-user .mine-lines span {
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        max-width: 200px;
        margin: 0 16px 0 6px;
      }

      .eol-right-user .mine-lines::after {
        content: '';
        display: inline-block;
        width: 12px;
        height: 12px;
        background-image: url('../../assets/site/header/icons-jiantou-down.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        margin-left: 4px;
      }

      .eol-right-user.up .mine-lines::after {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
      }

      .eol-right-user.down .mine-lines::after {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
      }

      .eol-right-user .user-imgs-box {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: middle;
        text-align: right;
        background: url('../../assets/site/header/mine-icons.png') no-repeat
          center;
        background-size: 100% auto;
      }

      .eol-right-user .eol-submine-box {
        background: #ffffff;
        border: 1px solid #dfe3e4;
        position: absolute;
        z-index: 1000;
        top: 80px;
        right: -12px;
        padding: 18px 15px 18px 20px;
        text-align: left;
        display: none;
        min-width: 130px;
        white-space: nowrap;
      }

      .eol-right-user.up .eol-submine-box {
        display: block;
      }

      .eol-right-user.down .eol-submine-box {
        display: none;
      }

      .eol-right-user .submine-items {
        height: 30px;
        color: #71737b;
        line-height: 30px;
        font-size: 14px;
        cursor: pointer;
      }
      .eol-right-user .submine-items a {
        display: block;
        width: auto;
        color: #71737b;
      }

      .eol-right-user .submine-items.active,
      .eol-right-user .submine-items:hover a {
        color: #3460e4;
        text-decoration: none;
      }

      .eol-right-user .mine-left-icons {
        width: 14px;
        height: 14px;
        margin-right: 6px;
        display: inline-block;
        vertical-align: -2px;
      }
    }
  }
}
</style>